import { z } from 'zod'
import { fallback } from '../../../utilities'

const positionOptions = ['top-left', 'top-right', 'bottom-left', 'bottom-right', 'hide'] as const

const fallbackData = {
	logo: 'top-left',
	location: 'top-right',
	attribution: 'bottom-right',

	stackOrientation: 'vertical',
} as const

export const feedAdPositioningSchema = z.object({
	logo: z.enum(positionOptions).or(fallback(fallbackData.logo)),
	location: z.enum(positionOptions).or(fallback(fallbackData.location)),
	attribution: z.enum(positionOptions).or(fallback(fallbackData.attribution)),
	stackOrientation: z.enum(['vertical', 'horizontal']).or(fallback(fallbackData.stackOrientation)),
}).or(fallback(fallbackData))

export type FeedAdPositioningConfiguration = z.infer<typeof feedAdPositioningSchema>

export const feedAdPositioningDefault: FeedAdPositioningConfiguration = feedAdPositioningSchema.parse({})
